import { render, staticRenderFns } from "./followshop.vue?vue&type=template&id=39cc13f6&scoped=true&"
import script from "./followshop.vue?vue&type=script&lang=js&"
export * from "./followshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc13f6",
  null
  
)

export default component.exports